// extracted by mini-css-extract-plugin
module.exports = {"header":"header_1f-hhx","operation-area":"operation-area_HPE0LG","operationArea":"operation-area_HPE0LG"};